import React from "react";

export const About = (props) => {
  return (
    <div id={props.data ? props.data.main.toLowerCase().replace(/ /g, "_") : "loading..."} className="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="about-text text-center">
              <h2>{props.data ? props.data.main : "loading..."}</h2>
              {props.data
                ? props.data.paragraphs.map((d, i) => (
                  <div key={`${i}`} className="col-md-12">
                    {" "}
                    <p>{d}</p>
                  </div>
                ))
                : "Loading..."}
              <div className="list-style">
                <div className="accordion accordion-flush" id="accordionFlush">
                  {props.data
                    ? props.data.Why.map((item, i) => (
                      <div key={`item-${i}`} className="accordion-item">
                        <h2 className="accordion-header" id={`flush-heading-${i}`}>
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#flush-collapse-${i}`}
                            aria-expanded="false"
                            aria-controls={`flush-collapse-${i}`}
                          >
                            {item.question}
                          </button>
                        </h2>
                        <div
                          id={`flush-collapse-${i}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`flush-heading-${i}`}
                          data-bs-parent="#accordionFlush"
                        >
                          <div className="accordion-body">
                            <p>{item.answer}</p>
                          </div>
                        </div>
                      </div>
                    ))
                    : "loading"}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
